<template>
  <div class="page">
    <div class="bg-content padding15 m-b-24">
      <el-form size="small" label-width="100px" class="margin15-tb">
        <p style="font-size: 20px">打标筛选</p>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="语料日期:">
              <el-date-picker style="width: 100%;"
                v-model="alg.startTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="至">
              <el-date-picker style="width: 100%;"
                v-model="alg.endTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="语料总数:" style="text-align:center">
              <label>{{this.alg.corpusSum}}</label>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="公司:">
              <el-select v-model="alg.companyName" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in companyNameList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.companyName"
                  :title="item.companyName">
                  <template>
                    <span v-if="item.companyName.length > 6">{{item.companyName.substring(0,6) + '...' + '(' + item.id + ')'}}</span>
                    <span v-else>{{item.companyName + '(' + item.id + ')'}}</span>
                  </template>
                </el-option>
                <template>
                  <span></span>
                </template>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="">
              <div></div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <div class="text right">
              <el-button type="primary" size="mini" @click="getCorpusSum" plain>确定</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="bg-content padding15 m-b-24">
      <el-form size="small" label-width="100px" class="margin15-tb">
        <p style="font-size: 20px">标数分配</p>
        <el-row :gutter="24">
          <template v-for="items of labelUsers">
            <el-col :span="8" v-if="items.userName" :key="items.userName">
              <el-form-item :label="items.userName" :title="items.userName">
                <el-input v-model="items.phone" :key="items.id" :value="items.phone"  @keyup.native="numberDays(items.phone,items.id)"></el-input>
              </el-form-item>
            </el-col>
          </template>
        </el-row>
        <div class="padding15-tb text right">
          <el-button type="primary" @click="submitAssignment" size="mini" plain>提交</el-button>
        </div>
      </el-form>
    </div>

    <div class="padding15 bg-content">
       <el-table
        size="small"
        v-loading="loading"
        :data="assignments"
        border
        :row-style="{cursor: 'pointer'}"
        highlight-current-row>
        <el-table-column
          property="userName"
          label="打标者"
          header-align="center"
          key="userName"
          align="center">
        </el-table-column>
        <el-table-column
          property="yesterdayNum"
          label="昨日分配量"
          header-align="center"
          key="yesterdayNum"
          align="center">
        </el-table-column>
        <el-table-column
          property="yesterdayComplete"
          label="昨日完成量"
          key="yesterdayComplete"
          header-align="center"
          align="center">
        </el-table-column>
        <el-table-column
          property="todayNum"
          label="今日分配量"
          key="todayNum"
          header-align="center"
          align="center">
        </el-table-column>
       </el-table>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      alg: {
        startTime: null,
        endTime: null,
        corpusSum: 0,
        companyName: []
      },
      companyNameList: [],
      labelUsers: [],
      assignments: [],
      loading: true
    };
  },
  mounted() {
    this.getTime();
    this.getCompanyAll();
    this.markLabelAssignment();
    this.getCorpusSum();
  },
  methods: {
    // 校验作业天数输入框
    numberDays(num, id) {
      num = num.replace(/[^\\.\d]/g, '');
      num = num.replace('.', '');
      if (num.substring(0, 1) === '0' && num.length > 1) {
        num = num.substring(1, num.length);
      }
      const labelUsers = this.labelUsers;
      labelUsers.forEach((item) => {
        if (item.id === id) {
          item.phone = num;
        }
      });
      this.labelUsers = labelUsers;
    },
    getTime() {
      const day = new Date();
      day.setTime(day.getTime() - (24 * 60 * 60 * 1000));
      const s = `${day.getFullYear()}-${day.getMonth() + 1}-${day.getDate()} 00:00:00`;
      this.alg.startTime = s;
      const dayEnd = new Date();
      dayEnd.setTime(dayEnd.getTime());
      const e = `${dayEnd.getFullYear()}-${dayEnd.getMonth() + 1}-${dayEnd.getDate()} 00:00:00`;
      this.alg.endTime = e;
    },
    // 获取公司下拉框
    getCompanyAll() {
      this.$ajax({
        url: '/markLabel/getCompanyName'
      }).then((res) => {
        this.companyNameList = res.data;
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    // 获取打标分配信息
    markLabelAssignment() {
      this.$ajax({
        url: '/markLabel/markLabelAssignment',
        method: 'get'
      }).then((res) => {
        console.warn(res);
        this.loading = false;
        this.labelUsers = res.data.userList;
        this.assignments = res.data.dtoList;
      });
    },
    // 获取语料总数
    getCorpusSum() {
      const startTime = this.alg.startTime;
      const endTime = this.alg.endTime;
      if (startTime && endTime && new Date(startTime).getTime() >= new Date(endTime).getTime()) {
        this.$message({
          type: 'error',
          message: '开始时间不能小于或等于结束时间'
        });
        return;
      }
      const query = this.alg;
      const loading = this.$partLoading();
      this.$ajax({
        url: '/markLabel/getCorpusSum',
        data: query
      }).then((res) => {
        loading.close();
        console.warn(res);
        this.alg.corpusSum = res.data;
      }).catch(() => {
        loading.close();
      });
    },
    // 提交分配
    submitAssignment() {
      const labelUsers = this.labelUsers;
      // 获取标数分配数据
      const assignmentData = {};
      if (labelUsers.length > 0) {
        let i = 0;
        labelUsers.forEach((item) => {
          if (!item.phone) {
            i = 1;
          }
          assignmentData[item.id] = item.phone;
        });
        if (i === 1) {
          this.$message({
            type: 'error',
            message: '分配参数不能为空!'
          });
          return;
        }
        // if (sum > this.alg.corpusSum) {
        //   this.$message({
        //     type: 'error',
        //     message: '分配参数不能大于语料总数!'
        //   });
        //   return;
        // }
      }
      const startTime = this.alg.startTime;
      const endTime = this.alg.endTime;
      if (startTime && endTime && new Date(startTime).getTime() >= new Date(endTime).getTime()) {
        this.$message({
          type: 'error',
          message: '开始时间不能小于或等于结束时间'
        });
        return;
      }
      const query = this.alg;
      query.assignmentDataJSON = JSON.stringify(assignmentData);
      const loading = this.$partLoading();
      this.$ajax({
        prompt: true,
        url: '/markLabel/submitAssignment',
        data: query
      }).then(() => {
        loading.close();
        this.markLabelAssignment();
        this.getCorpusSum();
      }).catch(() => {
        loading.close();
      });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/page/main/algCorpus/robotMarkLabelAssignment.vue